<div style="margin:1rem 1px 1.5rem 1px;display:flex;justify-content: center;">
    <div class="table-container" dir="ltr"
        [ngClass]="{ 'width-40': columnLength==1, 'width-60': columnLength==2 , 'width-75': columnLength==3, 'width-100': columnLength>3, 'rooty-table': rooty==true }" >
        <div class="table-data-container custom-scrollbar" #scrollContainer>
            <div [style.height.px]="topSpacerHeight"></div>
            <table mat-table [dataSource]="tableDataSource" style="min-width: 100%;" multiTemplateDataRows>
                <ng-container matColumnDef="expand" sticky>
                    <th mat-header-cell *matHeaderCellDef class="bold-header"></th>
                    <td mat-cell *matCellDef="let element" class="table-data" [ngClass]="{'expanded': true}">
                        <span class="icon material-symbols-rounded" *ngIf="element !== expandedElement" (click)="toggleExpand(element)">chevron_right</span>
                        <span class="icon material-symbols-rounded" *ngIf="element === expandedElement" (click)="toggleExpand(element)">expand_more</span>
                    </td>
                </ng-container>
                <!-- Sticky Columns -->
                <ng-container *ngFor="let column of stickyColumnNames" [matColumnDef]="column" sticky>
                    <th mat-header-cell *matHeaderCellDef class="bold-header"> {{ column | titlecase }} </th>
                    <td mat-cell class="table-data" *matCellDef="let element">
                        <div class="cell-content" >
                            <ng-container *ngIf="isUrl(element[column]); else stickyNonUrl">
                                <a [href]="element[column]" target="_blank" rel="noopener noreferrer" class="table-link">
                                    {{ element[column] }}
                                </a>
                            </ng-container>
                            <ng-template #stickyNonUrl>
                                {{element[column] !== null && element[column] !== undefined? (isUtcDate(element[column])? convertUTCToLocal(element[column]): element[column]): '-'}}
                            </ng-template>
                        </div>
                    </td>
                </ng-container>
                <!-- Scrollable Columns -->
                <ng-container *ngFor="let column of scrollableColumnNames" [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef class="bold-header"> {{ column | titlecase }} </th>
                    <td mat-cell class="table-data" *matCellDef="let element"  [ngClass]="{'expanded': expandedElement === element}">
                        <div class="cell-content" >
                            <ng-container *ngIf="isUrl(element[column]); else scrollNonUrl">
                                <a [href]="element[column]" target="_blank" rel="noopener noreferrer" class="table-link">
                                    {{ element[column] }}
                                </a>
                            </ng-container>
                            <ng-template #scrollNonUrl>
                                {{element[column] !== null && element[column] !== undefined? (isUtcDate(element[column]) ? convertUTCToLocal(element[column]) : element[column]): '-' }}
                            </ng-template>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let element" [attr.colspan]="totalColumns.length" class="detail-cell">
                        <div class="element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <table mat-table *ngIf="element[nestedColumnName] && element[nestedColumnName].length" [dataSource]="element[nestedColumnName]" class="nested-table">
                                <ng-container *ngFor="let nestedCol of nestedTableColumns" [matColumnDef]="nestedCol">
                                    <th mat-header-cell *matHeaderCellDef class="nested-header"> {{ nestedCol | titlecase }} </th>
                                    <td mat-cell *matCellDef="let nestedElement" class="nested-data">
                                        <div>
                                            <ng-container *ngIf="isUrl(nestedElement[nestedCol]); else nestedNonUrl">
                                                <a [href]="nestedElement[nestedCol]" target="_blank" rel="noopener noreferrer" class="table-link">
                                                    {{ nestedElement[nestedCol] }}
                                                </a>
                                            </ng-container>
                                            <ng-template #nestedNonUrl>
                                                {{nestedElement[nestedCol] !== null && nestedElement[nestedCol] !== undefined? (isUtcDate(nestedElement[nestedCol])? convertUTCToLocal(nestedElement[nestedCol]): nestedElement[nestedCol]): '-'}}
                                            </ng-template>
                                        </div>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="nestedTableColumns"></tr>
                                <tr mat-row *matRowDef="let nestedRow; columns: nestedTableColumns;"></tr>
                            </table>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="totalColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: totalColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
            </table>
            <div [style.height.px]="bottomSpacerHeight"></div>
        </div>
        <mat-paginator *ngIf="!rooty" #paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
            [length]="tableDataSource?.data?.length" aria-label="Select page"></mat-paginator>
        <div class="table-footer-container">
            <span>Total rows: {{dataSource?.length}}</span>
            <ng-content select="[downloadDataButton]"></ng-content>
        </div>
    </div>
</div>
